import {addHttpsToUrl, clearTokens, getRefreshToken} from "./utils";
import {post, get} from "../utils";

export default host => () => {
  if (getRefreshToken()) {
    const form = new FormData()
    form.append('redirect_url', window.location.protocol + '//' + window.location.hostname)
    post(`${host}/logout`, form)
      .then(result => result.json())
      .then(response => {
        clearTokens()
        if (response.redirectUrl) {
          window.location.href= addHttpsToUrl(response.redirectUrl)
        }else {
          window.location.reload()
        }
        // reloading will cause the router to redirect to login page.
      })
  }
}